import { render } from "./CometChatLiveReactions.vue?vue&type=template&id=487e2580"
import script from "./CometChatLiveReactions.vue?vue&type=script&lang=js"
export * from "./CometChatLiveReactions.vue?vue&type=script&lang=js"

import "./CometChatLiveReactions.vue?vue&type=style&index=0&id=487e2580&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__